"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calcPercentDiscountPrice;

function calcPercentDiscountPrice(prevPrice, percentDiscount) {
  return typeof prevPrice === 'number' ? prevPrice * (1 - (percentDiscount || 0)) : prevPrice;
}